import React from 'react';
import { motion } from 'framer-motion';
import { PrimaryButton, SecondaryButton } from './ui/UI';
import { Aurora } from './animations/Aurora';
import { BlurText } from './animations/BlurText';
import { DecryptedText } from './animations/DecryptedText';
import { ScrollFloat } from './animations/ScrollFloat';
import { Magnet } from './animations/Magnet';
import { RadarEcho } from './animations/RadarEcho';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative w-full py-40 border-t border-white/5 overflow-hidden" data-id="element-406">
      {/* Aurora wash for atmosphere */}
      <Aurora intensity={0.3} data-id="element-407" />

      {/* Background radar echo */}
      <RadarEcho intensity={0.2} data-id="element-408" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-409">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-410">
          <span className="inline-flex items-center justify-center gap-4 text-[#1a8fd4] text-[11px] font-mono uppercase tracking-[0.3em] mb-8" data-id="element-411">
            <span className="h-px w-10 bg-[#1a8fd4]/40" aria-hidden="true" data-id="element-412" />
            <DecryptedText text="Final" speed={50} data-id="element-413" />
            <span className="h-px w-10 bg-[#1a8fd4]/40" aria-hidden="true" data-id="element-414" />
          </span>

          {/* Headline with scroll-driven zoom */}
          <ScrollFloat scaleFrom={0.9} scaleTo={1} yFrom={30} data-id="element-415">
            <h2 className="text-5xl md:text-7xl lg:text-8xl font-semibold tracking-[-0.04em] leading-[0.95] text-white mb-8" data-id="element-416">
              Stop guessing.
              <br data-id="element-417" />
              <span className="text-white/40" data-id="element-418">Validate it.</span>
            </h2>
          </ScrollFloat>

          <p className="text-xl md:text-2xl text-white/70 max-w-2xl mx-auto mb-4" data-id="element-419">
            Periscan is coming back in 2026. Autonomous validation missions.
            Exposure validation. Control checks. Attack-path validation. AI app
            validation. Fix verification. Evidence packs. Self-service adoption.
          </p>

          <p className="font-mono text-base text-[#1a8fd4] mb-10" data-id="element-420">
            <DecryptedText text="Find the path. Validate the risk. Prove it's fixed." speed={30} data-id="element-421" />
          </p>

          {/* Dual CTAs — Coming Soon + Docs */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center" data-id="element-422">
            <Magnet strength={0.2} data-id="element-423">
              <a href="#" className="group inline-flex items-center gap-3 px-7 py-4 bg-white text-black font-medium rounded-full text-base hover:bg-white/90 transition-colors" data-id="element-424">
                <span data-id="element-425">Coming Soon</span>
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" data-id="element-426" />
              </a>
            </Magnet>
            <Magnet strength={0.15} data-id="element-427">
              <a href="/docs" className="group inline-flex items-center gap-3 px-7 py-4 bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium rounded-full text-base transition-colors backdrop-blur-sm" data-id="element-428">
                <span data-id="element-429">Read the Docs</span>
                <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-430" />
              </a>
            </Magnet>
          </div>

          <p className="mt-8 text-sm text-white/40 italic max-w-xl mx-auto" data-id="element-431">
            Free and open-source. Deploy in minutes. No sales calls required.
            <br data-id="element-432" />
            <span className="mt-2 block not-italic" data-id="element-433">
              Need a managed deployment?{' '}
              <a href="mailto:enterprise@periscan.com" className="text-[#1a8fd4] hover:text-white transition-colors" data-id="element-434">
                Ask about Periscan Enterprise.
              </a>
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}